import React from 'react'
import DefaultProductStatus from '../../DefaultProductStatus'

const AdvertisingProduct = ({product}) => {
  if (product.state === 'delivered') {
    return (
      <p>
        Dette produktet er en kampanje som leveres utenfor Meglerappen.
        Ta kontakt med EFKT ved spørsmål.
      </p>
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

export default AdvertisingProduct
